module.exports = __webpack_public_path__ + "static/media/a1.75e3afe.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caoxi/a1.mp3
// module id = DjG4
// module chunks = 0